import React from 'react'
import * as Sentry from '@sentry/browser'
import ErrorUpdateMessage from './ErrorUpdateMessage'

function isChunkLoadError(error: any): boolean {
  if (!error) return false
  const msg = error.message || ''
  return (
    error.name === 'ChunkLoadError' ||
    msg.includes('Loading chunk') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed')
  )
}

export default class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false, isAppUpdate: false }
  }

  static getDerivedStateFromError(error: any) {
    Sentry.captureException(error)
    return { hasError: true, isAppUpdate: isChunkLoadError(error) }
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error('[ErrorBoundary] Caught error:', error)
    console.error('[ErrorBoundary] Component stack:', errorInfo?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return <ErrorUpdateMessage isAppUpdate={this.state.isAppUpdate} />
    }
    return this.props.children
  }
}
